import { SCORE_COLOR, getSatisfactionIcon } from '@/components/ui/feedback-bar'
import type { RobotFeedback } from '@/api/feedbacks.api'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'
import { SATISFACTION_EXCEL_STYLES } from '../counter-feedback/columnsCounter'

interface BuildRobotColumnsOptions {
    pageIndex: number
    pageSize: number
    showUnitColumn?: boolean
}

export function buildRobotColumns(
    options: BuildRobotColumnsOptions,
): CombinedColumnDef<RobotFeedback>[] {
    const { pageIndex, pageSize, showUnitColumn = false } = options

    const getSafeText = (value: unknown, fallback = '--') => {
        if (typeof value === 'string' && value.trim()) return value
        if (typeof value === 'number') return String(value)
        return fallback
    }

    return [
        {
            id: 'stt',
            header: 'STT',
            size: 55,
            align: 'center',
            cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
        },
        {
            accessorKey: 'createdAt',
            header: 'NGÀY THỰC HIỆN',
            size: 150,
            align: 'center',
            cell: ({ getValue }) => formatDateTime(getValue() as string),
        },
        ...(showUnitColumn
            ? [
                {
                    id: 'unitName',
                    accessorKey: 'unitName',
                    header: 'ĐƠN VỊ',
                    size: 200,
                    align: 'left',
                    cell: ({ row }) => getSafeText(row.original.unitName),
                } satisfies CombinedColumnDef<RobotFeedback>,
            ]
            : []),
        {
            id: 'robotName',
            accessorKey: 'robotName',
            header: 'ROBOT',
            size: 150,
            align: 'left',
            cell: ({ row }) => getSafeText(row.original.robotName),
        },
        {
            accessorKey: 'satisfactionScore',
            header: 'ĐÁNH GIÁ',
            size: 150,
            align: 'left',
            exportStatusStyles: SATISFACTION_EXCEL_STYLES,
            cell: ({ row, getValue }) => {
                const score = getValue()
                const label = row.original.satisfactionLevel
                return (
                    <div
                        className={`flex items-center gap-1.5 text-xs ${SCORE_COLOR[score] ?? 'text-gray-700'}`}
                    >
                        {getSatisfactionIcon(score)}
                        <span>{label}</span>
                    </div>
                )
            },
        },
        {
            id: 'satisfactionContent',
            accessorKey: 'satisfactionContent',
            header: 'NỘI DUNG ĐÁNH GIÁ',
            size: 350,
            align: 'left',
            cell: ({ row }) => {
                const text = getSafeText(row.original.satisfactionContent, '')
                return (
                    <div className="line-clamp-2" title={text}>
                        {text}
                    </div>
                )
            },
        },
    ]
}
